<div *ngIf="(vm$ | async) as vm">
    <app-page-header [vm]="vm" title='Trend Reports Dashboard' [canGoBack]="true" [canRefresh]="true"
        (refreshClick)="refreshPage()" [notify]="notifyObj"></app-page-header>

    <mdb-card class="mb-3" cascade="true" narrower="true" *ngIf="vm.filterVm as fvm" style="height: 5rem">
        <mdb-card-body cascade="true" class="py-2">
            <div class="row">
                <div class="col-md-3 mt-n3 mb-0">
                    <app-form-input [vm]="fvm.fromDateInputVm" (textChanged)="requestFormValidate(vm)"></app-form-input>
                </div>
                <div class="col-md-3 mt-n3 mb-0">
                    <app-form-input [vm]="fvm.toDateInputVm" (textChanged)="requestFormValidate(vm)"></app-form-input>
                </div>
                <div class="col-md-3 mt-n3 mb-0">
                    <app-form-select [vm]="fvm.yearToCompareVm"
                            [optionValue]="fvm.data.yearToCompare"
                            (selectChanged)="yearToCompareChanged($event, vm)"></app-form-select>
                </div>
                <div class="col-md-1 mt-1 mb-0">
                    <a mdbBtn floating="true" size="sm" gradient="blue" mdbWavesEffect (click)="doSearch(vm)"
                        mdbTooltip="Search">
                        <mdb-icon fas icon="search"></mdb-icon>
                    </a>
                </div>
            </div>
        </mdb-card-body>
    </mdb-card>

    <!-- content -->
    <div *ngIf="vm.dashboardVm as dvm">
        <!-- working -->
        <div class="row" *ngIf="dvm.workingText">
            <div class="col-md-12">
                <div class="text-center">
                    <div>{{dvm.workingText}}</div>
                    <mdb-spinner spinnerColor="blue"></mdb-spinner>
                </div>
            </div>
        </div>

        <!-- error -->
        <div class="row" *ngIf="dvm.errorText">
            <div class="col-md-12">
                <div class="text-center text-danger">
                    <div>{{dvm.errorText}}</div>
                </div>
            </div>
        </div>

        <!-- tabs -->
        <div class="mt-3" *ngIf="!dvm.workingText && !dvm.errorText">
            <mdb-tabset #staticTabs [buttonClass]="'md-tabs blue-gradient'" [contentClass]="'card'" *ngIf="dvm.tabVms"
                (getActiveTab)="onGetActiveTab(vm, $event)">
                <mdb-tab *ngFor="let tvm of dvm.tabVms" [heading]="tvm.title">
                    <div class="row py-3">
                        <div class="col-md-4" *ngIf="tvm.chartVm.revenueVm as cvm">
                            <app-card-chart [vm]="vm" [cvm]="cvm" [headingSize]="5" [fullHeader]="true"
                                (viewDetailsClicked)="viewDetailsClicked(cvm.clientRoute, '1')"></app-card-chart>
                        </div>

                        <div class="col-md-4" *ngIf="tvm.chartVm.tripsCountVm as cvm">
                            <app-card-chart [vm]="vm" [cvm]="cvm" [headingSize]="5" [fullHeader]="true"
                                (viewDetailsClicked)="viewDetailsClicked(cvm.clientRoute, '2')"></app-card-chart>
                        </div>

                        <div class="col-md-4" *ngIf="tvm.chartVm.averageTicketPriceVm as cvm">
                            <app-card-chart [vm]="vm" [cvm]="cvm" [headingSize]="5" [fullHeader]="true"
                                (viewDetailsClicked)="viewDetailsClicked(cvm.clientRoute, '3')"></app-card-chart>
                        </div>
                    </div>

                    <div class="row py-3">
                        <div class="col-md-4" *ngIf="tvm.chartVm.averageTripDistanceVm as cvm">
                            <app-card-chart [vm]="vm" [cvm]="cvm" [headingSize]="5" [fullHeader]="true"
                                (viewDetailsClicked)="viewDetailsClicked(cvm.clientRoute, '4')"></app-card-chart>
                        </div>

                        <div class="col-md-4" *ngIf="tvm.chartVm.averageTimeVm as cvm">
                            <app-card-chart [vm]="vm" [cvm]="cvm" [headingSize]="5" [fullHeader]="true"
                                (viewDetailsClicked)="viewDetailsClicked(cvm.clientRoute, '5')"></app-card-chart>
                        </div>
                    </div>
                </mdb-tab>
            </mdb-tabset>
        </div>
    </div>

</div>